<template>
  <el-drawer :visible.sync="dialogVisible"
             title="添加医生"
             append-to-body
             custom-class="add-dialog"
             :wrapperClosable="false"
             :show-close="false" size="600px" class="drawerCommon">
    <el-form :model="form" label-width="150px" label-suffix="：" class="maxHeight">
      <el-divider content-position="left"><span style="font-weight: bold">账户信息</span></el-divider>
      <el-form-item label="账户名称" required>
        <el-input v-model="form.account" class="short-input" style="width: 200px" placeholder="医生账户名/登录名"></el-input>
        <span style="margin-left: 10px;color: #F56C6C;font-size: 12px">可作为登录账户,限字母、数字、下划线</span>
      </el-form-item>
      <el-form-item label="医生主页地址">
        <p>{{ webUrl }}/{{ form.account }}</p>
      </el-form-item>
      <el-form-item label="登录密码" required>
        <el-input type="password" v-model="form.password" class="short-input" placeholder="账户登录密码"></el-input>
      </el-form-item>
      <el-form-item label="邮箱">
        <el-input v-model="form.email" class="short-input" placeholder="邮箱"></el-input>
      </el-form-item>
      <el-form-item label="手机">
        <el-input v-model="form.mobile" class="short-input" placeholder="手机"></el-input>
      </el-form-item>
      <el-divider content-position="left"><span style="font-weight: bold">基本信息</span></el-divider>
      <el-form-item label="头像" required>
        <el-upload class="avatar-uploader"
                   :action="uploadUrl.headImg"
                   :show-file-list="false"
                   name="uploadFile"
                   :on-success="handleAvatarSuccess">
          <img v-if="form.headImgPath" :src="form.headImgPath" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="类型" required>
        <el-radio-group v-model="form.medicineType">
          <el-radio label="1">医生</el-radio>
          <el-radio label="2">咨询师</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="form.fullName" class="short-input" placeholder="姓名"></el-input>
      </el-form-item>
      <el-form-item label="英文名">
        <el-input v-model="form.enName" class="short-input" placeholder="英文名"></el-input>
      </el-form-item>
      <el-form-item label="性别" required>
        <el-radio-group v-model="form.gender">
          <el-radio label="1">男</el-radio>
          <el-radio label="0">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="开始行医时间" required>
        <el-date-picker v-model="form.startWorkDate"></el-date-picker>
      </el-form-item>
      <el-form-item label="年龄">
        <el-input-number v-model="form.age" :min="18" :max="120"></el-input-number>
      </el-form-item>
      <el-form-item label="所在城市">
        <el-input v-model="form.abodeCity" placeholder="所在城市"></el-input>
      </el-form-item>
      <el-form-item label="所在单位">
        <el-input v-model="form.company" placeholder="所在单位"></el-input>
      </el-form-item>
      <el-form-item label="科室/部门">
        <el-input v-model="form.department" placeholder="科室/部门"></el-input>
      </el-form-item>
      <el-form-item label="职位">
        <el-input v-model="form.job" placeholder="职位"></el-input>
      </el-form-item>
      <el-form-item label="职称">
        <el-input v-model="form.technicalTitle" placeholder="职称"></el-input>
      </el-form-item>
      <el-form-item label="专长">
        <el-input v-model="form.skill" placeholder="专长"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" placeholder="备注"></el-input>
      </el-form-item>
      <el-divider content-position="left"><span style="font-weight: bold">补充信息</span></el-divider>
      <el-form-item label="签名">
        <el-input v-model="form.supplement.signature" placeholder="签名"></el-input>
      </el-form-item>
      <el-divider content-position="left"><span style="font-weight: bold">资质信息</span></el-divider>
      <el-form-item label="资格证书编号">
        <el-input v-model="form.licenceNo" placeholder="资格证书编号"></el-input>
      </el-form-item>
      <el-form-item label="资格证书发证日期">
        <el-date-picker v-model="form.licenceIssuedDate"></el-date-picker>
      </el-form-item>
      <el-form-item label="资质证书">
        <el-upload class="avatar-uploader"
                   :action="uploadUrl.licence"
                   :show-file-list="false"
                   name="uploadFile"
                   :on-success="handleLicenceSuccess">
          <img v-if="form.licenceFilePath" :src="form.licenceFilePath" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="执业证书编号">
        <el-input v-model="form.certNo" placeholder="执业证书编号"></el-input>
      </el-form-item>
      <el-form-item label="执业证书发证日期">
        <el-date-picker v-model="form.certIssuedDate"></el-date-picker>
      </el-form-item>
      <el-form-item label="执业证书">
        <el-upload class="avatar-uploader"
                   :action="uploadUrl.cert"
                   :show-file-list="false"
                   name="uploadFile"
                   :on-success="handleCertSuccess">
          <img v-if="form.certFilePath" :src="form.certFilePath" class="avatar"/>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-divider content-position="left"><span style="font-weight: bold">银行信息</span></el-divider>
      <el-form-item label="银行名称">
        <el-input v-model="form.bankName" placeholder="银行名称"></el-input>
      </el-form-item>
      <el-form-item label="银行账户名">
        <el-input v-model="form.bankAccountName" placeholder="银行账户名"></el-input>
      </el-form-item>
      <el-form-item label="银行卡号">
        <el-input v-model="form.bankAccountNo" placeholder="银行卡号"></el-input>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button type="primary" size="small" @click="save" :loading="loading">保存</el-button>
      <el-button size="small" @click="dialogVisible=false,loading=false">取消</el-button>
    </div>
  </el-drawer>
</template>

<script>
import base from '@/api/common';

export default {
  name: "doctorAddDialog",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      uploadUrl: {
        headImg: base.headImgUploadUrl,
        licence: base.uploadUrl + 'licence',
        cert: base.uploadUrl + 'cert'
      },
      webUrl: base.web_url,
      form: {
        account: '',
        password: '',
        fullName: '',
        enName: '',
        gender: '1',
        age: 18,
        medicineType: '1',
        startWorkDate: '',
        abodeCity: '',
        company: '',
        skill: '',
        department: '',
        job: '',
        technicalTitle: '',
        mobile: '',
        email: '',
        headImgPath: '',
        licenceNo: '',
        licenceIssuedDate: '',
        licenceFilePath: '',
        certNo: '',
        certIssuedDate: '',
        certFilePath: '',
        bankName: '',
        bankAccountName: '',
        bankAccountNo: '',
        remark: '',
        supplement: {
          signature: '',
          briefDesc: '',
          honors: '',
          eduBackground: '',
          certSource: ''
        },
      }
    }
  },
  methods: {
    handleAvatarSuccess(res, file, fileList) {
      if (res.status == 'success') {
        this.form.headImgPath = res.message;
      } else {
        this.$message.error("上传失败");
      }
    },
    handleLicenceSuccess(res, file, fileList) {
      if (res.status == 'success') {
        this.form.licenceFilePath = res.message;
      } else {
        this.$message.error("上传失败");
      }
    },
    handleCertSuccess(res, file, fileList) {
      if (res.status == 'success') {
        this.form.certFilePath = res.message;
      } else {
        this.$message.error("上传失败");
      }
    },
    save() {
      let that = this;
      if ($.trim(that.form.account).length === 0) {
        that.$message.warning("账户名称不能为空");
        return
      }
      if (!base.reg.account.test(that.form.account)) {
        that.$message.warning("账户名称不符合规范:4-16位、仅字母、数字");
        return
      }
      if ($.trim(that.form.password).length === 0) {
        that.$message.warning("密码不能为空");
        return
      }
      //if($.trim(that.form.email).length === 0){ that.$message.warning("邮箱不能为空"); return}
      //if(!base.reg.email.test(that.form.email)){ that.$message.warning("邮箱不符合规范"); return}
      //if($.trim(that.form.mobile).length === 0){ that.$message.warning("手机号码不能为空"); return}
      //if(!base.reg.mobile.test(that.form.mobile)){ that.$message.warning("手机号码不符合规范"); return}
      if ($.trim(that.form.headImgPath).length === 0) {
        that.$message.warning("请先上传头像");
        return
      }
      if (that.form.medicineType != 1 && that.form.medicineType != 2) {
        that.$message.warning("类型不正确");
        return
      }
      if ($.trim(that.form.fullName).length === 0 && $.trim(that.form.enName).length === 0) {
        that.$message.warning("姓名与英文名不能同时为空");
        return
      }
      if (that.form.gender != 0 && that.form.gender != 1) {
        that.$message.warning("请选择性别");
        return
      }
      if (!that.form.startWorkDate) {
        that.$message.warning("请选择开始行医时间");
        return
      }

      let data = JSON.parse(JSON.stringify(that.form));
      // 时间处理
      if (data.startWorkDate) {
        data.startWorkDate = new Date(data.startWorkDate).Format('yyyy-MM-dd HH:mm:ss');
      }
      if (data.licenceIssuedDate) {
        data.licenceIssuedDate = new Date(data.licenceIssuedDate).Format('yyyy-MM-dd HH:mm:ss');
      }
      if (data.certIssuedDate) {
        data.certIssuedDate = new Date(data.certIssuedDate).Format('yyyy-MM-dd HH:mm:ss');
      }

      that.loading = true;
      that.$ajax.post(base.basePath + "auth/auth-doctor/admin/save", data).then(res => {
        if (res.data.status == 'success') {
          that.$message.success('保存成功');
          that.dialogVisible = false;
          that.loading = false;
        } else {
          that.$message.error(res.data.message);
        }
      }).catch(err => {
        console.error(err);
        that.loading = false;
        that.$message.error('保存失败')
      })

    }
  }
}
</script>

<style lang="scss" scoped>

.el-dialog__wrapper {
  display: block;

  .add-dialog {
    max-height: 760px;
  }
}
</style>
<style lang="css">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.el-form-add {
  display: block;
  max-height: 600px;
  overflow-y: scroll;
}

.el-form-add div.short-input {
  max-width: 300px;
}
</style>